import type { VideoResolution } from '@byokapp/types'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

interface ResolutionPickerProps {
  options: VideoResolution[]
  value: VideoResolution
  onChange: (v: VideoResolution) => void
}

const LABELS: Record<VideoResolution, string> = {
  '720p': '720p',
  '1080p': '1080p',
  '4k': '4K',
}

export function ResolutionPicker({ options, value, onChange }: ResolutionPickerProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label>Resolution</Label>
      <div className="flex gap-1.5">
        {options.map((r) => (
          <Button
            key={r}
            size="sm"
            variant={value === r ? 'default' : 'outline'}
            onClick={() => onChange(r)}
            className="text-xs px-3"
          >
            {LABELS[r]}
          </Button>
        ))}
      </div>
    </div>
  )
}
